import { HStack } from '@chakra-ui/react';
import { t } from '@lingui/macro';
import React from 'react';

import pppLogoImage from '../../../../../../assets/images/3p_logo.svg';
import { ProductLogo } from '../../../product-logo';
import { OverlayContentBackground } from '../../product-licence-manager.styled';

export type LicenceExpiryOverlayProps = {
    messageText: string
    productIcon: string | null
};

export const LicenceErrorOverlay = ({
    messageText, productIcon
}: LicenceExpiryOverlayProps) => {
    return (
        <OverlayContentBackground data-testid={'licence-error-overlay'}>
            {productIcon && <ProductLogo />}

            {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
            <p dangerouslySetInnerHTML={{ __html: messageText }} />

            <HStack>
                <span>{t`licence.error.product.title`}</span>
                <img
                    alt={'3P Learning'}
                    src={pppLogoImage}
                    width={150}
                />
            </HStack>
        </OverlayContentBackground>
    );
};

